import { cn } from "@/lib/utils";
import { useQueryState } from "nuqs";
import { useEffect, useRef, useState } from "react";
import { AgentConversationBox } from "./components/agent-conversation-box";
import { AgentConversationList } from "./components/agent-conversion-list";

import { useMediaQuery } from "@/hooks/use-media-query";
import { useAgentConversationStore } from "./utils/agent-conversation-store";

type TabType = "public" | "private";

export const AgentConversation = ({ agentId }: { agentId: string }) => {
  const [sessionId] = useQueryState("session_id", {
    defaultValue: "",
  });
  const [detailsPanel, setDetailsPanel] = useQueryState("details_panel");
  const prevSessionIdRef = useRef(sessionId);

  const [selectedConversationTitle, setSelectedConversationTitle] = useState("");
  const [selectedConversationUser, setSelectedConversationUser] = useState("");
  const [activeTab, setActiveTab] = useState<TabType>("public");

  useEffect(() => {
    if (prevSessionIdRef.current !== sessionId) {
      setDetailsPanel(null);
      prevSessionIdRef.current = sessionId;
    }
  }, [sessionId, setDetailsPanel]);

  const { detailsWidth } = useAgentConversationStore();
  const isDesktop = useMediaQuery("(min-width: 768px)");

  return (
    <div className="flex h-[calc(100vh-220px)] w-full gap-5">
      <div className={cn("w-full md:w-[35%] md:max-w-96", sessionId && "hidden md:block")}>
        <AgentConversationList
          agentId={agentId}
          setSelectedConversationTitle={setSelectedConversationTitle}
          setSelectedConversationUser={setSelectedConversationUser}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </div>
      <div
        className={cn(
          "hidden min-w-[380px] flex-1 gap-5 transition-all duration-300 ease-in-out md:flex",
          sessionId && "flex",
        )}
        style={{ marginRight: detailsPanel && isDesktop ? `${detailsWidth}px` : "0px" }}
      >
        <AgentConversationBox
          agentId={agentId}
          title={selectedConversationTitle}
          username={selectedConversationUser}
          isPrivate={activeTab === "private"}
        />
      </div>
    </div>
  );
};
